import styled from "styled-components";

const FormLoading = () => {
  return (
    <Div>
      <div className="app-container">
        <div id="skeleton-screen">
          <div className="forms grid gap-3 grid-cols-3">
            {Array.from({ length: 10 }, (_, index) => (
              <div key={index} className="field">
                <div className="lebel skeleton"></div>
                <div className="input skeleton"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Div>
  );
};
export default FormLoading;

const Div = styled("div")`
  .app-container {
    height: 100%;
    overflow: hidden;
    position: relative;
  }

  /* Skeleton Components */
  .skeleton {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
  }

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }

  .forms {
    border: 1px solid rgb(228 231 236 / var(--tw-border-opacity, 1));
    padding: 10px;
  }
  .field {
    height: 40px;
  }
  .lebel {
    height: 10px;
    width: 40%;
  }
  .input {
    margin: 5px 0 0;
    height: 30px;
    border: 1px solid #eaeaea;
  }
`;
